<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

a:hover {
    text-decoration: none;
}
* {   
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

$klz-red: #c50c0e;
.btn-all {

    border: 0;
    background: none;
    background: #eee;
    padding: 10px 15px;
    margin-top: 10px;
    text-transform: uppercase;
    font-size: 80%;
    letter-spacing: 1px;
    @media(max-width:768px) {
        width: 100%;
        display: block;
    }
    &:hover {
        background: $klz-red;
        color: #fff;
    }

    &.red {
        background: $klz-red;
        color: #fff;
    }
}
</style>

<template>
<div id="app">
  <Messages />
  <Nav />
  <LoginBar />
  <router-view />
</div>
</template>

<script type="ts">
import Vue from 'vue';
import Nav from '@/components/Nav.vue'
import LoginBar from '@/components/LoginBar.vue'
import Messages from '@/components/Messages.vue'

export default Vue.extend({
  name: 'App',
  components: {
    Nav,
    LoginBar,
    Messages
  },
  created() {
    Promise.all([this.$store.dispatch('loadBranchen'), this.$store.dispatch('loadMeta')])
      .then(() => {
          const hashes = this.parseUrl(window.location).hash.split("/");

          if (hashes.length > 0 && hashes[0] != "") {
            this.$store.dispatch('filterHashes', hashes);
          }

          this.$store.dispatch('loadUnternehmen');
        });

  const store = this.$store;



  //this.$store.dispatch('addMessage', {message:"Hi!", type:"error"});

  if (store.getters.loggedIn) {
    store.dispatch('refreshToken');
  }

  setInterval(function() {
    if (store.getters.loggedIn) {
      store.dispatch('refreshToken');
    }
  }, 1000 * 60 * 5); // Every 5 minutes
},
methods: {
  parseUrl: function(url) {
    const parser = document.createElement('a');
    parser.href = url;
    return parser;
  }
}
});
</script>
